export default __webpack_public_path__ + "static/media/star_white.4c4b5ec6.svg";